import { render, staticRenderFns } from "./ProjectTeamHeader.vue?vue&type=template&id=cbfff8d0"
import script from "./ProjectTeamHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectTeamHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports